import { Body, Controller, NotFoundException, Param, Post } from '@nestjs/common'
import { WebhookAplicacionService } from '../../../../plataforma/services/aplicacion.server.services'
import { WebhookSmsServerService } from '../../../services/sms/sms.server.service'

@Controller('webhook/mensaje/sms/:apiKey')
export class WebhookDispatcherMensajeSmsController {
  constructor(
    private aplicacionService: WebhookAplicacionService,
    private webhookSmsServerService: WebhookSmsServerService,
  ) {}

  @Post()
  async post(@Param('apiKey') apiKey: string, @Body() data: any) {
    if (!apiKey) {
      throw new NotFoundException('No hay una key válido')
    }
    const aplicacion = await this.aplicacionService.obtenerAplicacionApi(apiKey)
    const dataMensaje = {
      ...data,
      key: aplicacion.token,
    }

    await this.webhookSmsServerService.send(dataMensaje)

    return { status: 'true' }
  }
}
